export interface IPrinter {
  id: string;
  store_id: string;
  serial_number: string;
  password?: string;
  created_at: string;
}

export type PrinterPayload = {
  id: string;
  store_id: string;
  serial_number: string;
  password?: string;
};

export class Printer implements IPrinter{
  public id = '';
  public store_id = '';
  public store_name = '';
  public serial_number = '';
  public password?: string;
  public created_at: string;

  constructor(args: IPrinter) {
    this.id = args.id;
    this.store_id = args.store_id;
    this.serial_number = args.serial_number;
    this.created_at = args.created_at;
    this.password = args.password;
  }

  public payload(): PrinterPayload {
    const payload: PrinterPayload = {
      id: this.id,
      store_id: this.store_id,
      serial_number: this.serial_number,
      password: this.password
    };

    return payload;
  }
}
